export default __webpack_public_path__ + "static/media/answers_long.f7d1c9fa.svg";